module.exports = __webpack_public_path__ + "img/menu-icon-4-2.13977e24.svg";